module.exports = __webpack_public_path__ + "media/images/illustration_13-dffb7154a8ac6109e669cc129bbdb196.png";